import { c as _c } from "react/compiler-runtime";
import { FormInput } from '@systemeio/ui';
import { replaceWwwForHosts } from '@systemeio/util';
import React from 'react';
import { isClient } from 'shared/components/screen-height-div';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SubdomainInputProps {
  subdomain: string;
  mainDomain?: string;
  error: string;
  onChange: (value: string) => void;
}
const defaultMainDomain = isClient() ? `.${replaceWwwForHosts(window.location.host)}` : undefined;
export const getSubdomainFromDomain = (domain: string, mainDomain = defaultMainDomain) => {
  if (!isClient() || !mainDomain) return;
  return domain.split(mainDomain)?.[0];
};
export function SubdomainInput(t0) {
  const $ = _c(10);
  const {
    subdomain,
    mainDomain: t1,
    error,
    onChange
  } = t0;
  const mainDomain = t1 === undefined ? defaultMainDomain : t1;
  const {
    t
  } = useLocoTranslation();
  let t2;
  if ($[0] !== t) {
    t2 = t("global.subdomain");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onChange) {
    t3 = e => onChange(e.target.value);
    $[2] = onChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== error || $[5] !== mainDomain || $[6] !== subdomain || $[7] !== t2 || $[8] !== t3) {
    t4 = <FormInput label={t2} value={subdomain} onChange={t3} spellCheck={false} error={error} addonBefore={`${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://`} addonAfter={mainDomain} />;
    $[4] = error;
    $[5] = mainDomain;
    $[6] = subdomain;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}